import axiosInstance from "../instance/axiosInstance";

class ClientsApi {
  static async clientsList(page, searchQuery, type, paginate = true) {
    let url = `/organization/client/list?page=${page}`;

    if (searchQuery) {
      url += `&search_value=${encodeURIComponent(searchQuery)}`;
    }

    if (type !== null && type !== undefined) {
      url += `&search_type=${encodeURIComponent(type)}`;
    }
      url += `&paginate=${encodeURIComponent(paginate)}`;

    try {
      const response = await axiosInstance.get(url);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }

  static async createClient(formData) {
    try {
      const response = await axiosInstance.post(
        "/organization/client/save",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      return error;
    }
  }

  static async deleteClient(id) {
    try {
      const response = await axiosInstance.get(
        `/organization/client/delete/${id}`
      );
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }

  static async getEditClientInfo(clientId) {
    try {
      const response = await axiosInstance.get(
        `/organization/client/edit/${clientId}`
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getClientInfo(clientId) {
    try {
      const response = await axiosInstance.get(
        `/organization/client/view/${clientId}`
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
}

export default ClientsApi;
